import type { RouteRecordRaw } from 'vue-router';

const adminMeta = {
  moduleId: 'tracker' as const,
  requiresPermission: 'admin:all',
};

/** Same settings shell for both tabs (DxTabPanel syncs URL). */
const settingsComponent = () => import('./pages/SettingsPage.vue');

/** Same groups shell for link/domain group tabs. */
const groupsComponent = () => import('./pages/GroupsPage.vue');

export const routes: RouteRecordRaw[] = [
  {
    path: '/tracker',
    redirect: '/tracker/links',
  },
  {
    path: '/tracker/links',
    component: () => import('./pages/LinksPage.vue'),
    meta: { title: 'Ссылки', moduleId: 'tracker' },
  },
  {
    path: '/tracker/links/targets/:targetKey',
    component: () => import('./pages/TargetDetailPage.vue'),
    meta: { title: 'Target', moduleId: 'tracker' },
    props: true,
  },
  {
    path: '/tracker/links/:id',
    component: () => import('./pages/LinkDetailPage.vue'),
    meta: { title: 'Ссылка', moduleId: 'tracker' },
    props: true,
  },
  {
    path: '/tracker/domains',
    component: () => import('./pages/DomainsPage.vue'),
    meta: { title: 'Домены', moduleId: 'tracker' },
  },
  {
    path: '/tracker/nodes',
    component: () => import('./pages/TrackerNodesPage.vue'),
    meta: { title: 'Edge-ноды', moduleId: 'tracker' },
  },
  {
    path: '/tracker/groups',
    redirect: '/tracker/groups/links',
  },
  {
    path: '/tracker/groups/links',
    component: groupsComponent,
    meta: { title: 'Группы ссылок', moduleId: 'tracker' },
  },
  {
    path: '/tracker/groups/domains',
    component: groupsComponent,
    meta: { title: 'Группы доменов', moduleId: 'tracker' },
  },
  {
    path: '/tracker/domain-groups',
    redirect: '/tracker/groups/domains',
  },
  {
    path: '/tracker/settings',
    redirect: '/tracker/settings/bot-policies',
  },
  {
    path: '/tracker/settings/bot-policies',
    component: settingsComponent,
    meta: { title: 'Политики ботов', ...adminMeta },
  },
  {
    path: '/tracker/settings/geo',
    component: settingsComponent,
    meta: { title: 'Базы GEO', ...adminMeta },
  },
];
